import { CalendarDays } from "lucide-react";
import { useState } from "react";

export const TIME_SLOTS = ["09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00"];

export function todayIsoDate() {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 10);
}

export function formatAppointment(date, time) {
  if (!date) return "";
  const parsed = new Date(`${date}T12:00:00`);
  const dateLabel = Number.isNaN(parsed.getTime()) ? date : new Intl.DateTimeFormat("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" }).format(parsed);
  return time && time !== "flexibel" ? `${dateLabel}, ${time} Uhr` : `${dateLabel}, Uhrzeit nach Absprache`;
}

export default function AppointmentPicker({ vehicle, onRequest }) {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("10:00");
  const label = formatAppointment(date, time);

  return (
    <div className="appointment-card" data-testid="appointment-card">
      <div className="appointment-head"><CalendarDays size={18} strokeWidth={1.5} /><div><strong>Besichtigung anfragen</strong><span>Wunschtermin wählen – wir bestätigen persönlich per E-Mail.</span></div></div>
      <div className="appointment-fields">
        <label htmlFor="appointment-date">Wunschdatum<input id="appointment-date" type="date" min={todayIsoDate()} value={date} onChange={(event) => setDate(event.target.value)} data-testid="appointment-date-input" /></label>
        <label htmlFor="appointment-time">Uhrzeit<select id="appointment-time" value={time} onChange={(event) => setTime(event.target.value)} data-testid="appointment-time-select"><option value="flexibel">Nach Absprache</option>{TIME_SLOTS.map((slot) => <option key={slot} value={slot} label={`${slot} Uhr`} />)}</select></label>
      </div>
      {label && <p className="appointment-preview" data-testid="appointment-preview">Ihr Wunschtermin: <strong>{label}</strong></p>}
      <button className="button button-primary" type="button" disabled={!date} onClick={() => onRequest(vehicle, { date, time, label })} data-testid="appointment-request-button"><CalendarDays size={16} /> Besichtigung anfragen</button>
    </div>
  );
}
